import getValueFromQuery from 'utils/getValueFromQuery';
export default function getForcedBuckets() {
    return getValueFromQuery('ss_pathfinder_force_bucket');
}
